module.exports = __webpack_public_path__ + "img/thumbnail_Emu_f_leucistic.a7c9e6fc.png";